import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FormComponent } from './form.component';
import { FormEffects } from './store/form.effects';
import { formReducer } from './store/form.reducer';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    StoreModule.forFeature('form', formReducer),
    EffectsModule.forFeature([FormEffects]),
  ],
  declarations: [FormComponent],
  exports: [FormComponent],
})
export class FormModule {}
